// extracted by mini-css-extract-plugin
module.exports = {"expandIcon":"cwsx7","header":"blIvi","content":"_2X5X0","expanded":"_2qeQi","title":"_2F01m"};